import { render, staticRenderFns } from "./SchoolPrizeManage.vue?vue&type=template&id=60dda092&scoped=true"
import script from "./SchoolPrizeManage.vue?vue&type=script&lang=js"
export * from "./SchoolPrizeManage.vue?vue&type=script&lang=js"
import style0 from "./SchoolPrizeManage.vue?vue&type=style&index=0&id=60dda092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dda092",
  null
  
)

export default component.exports